<template>
  <div
    class="difficulty-badge inline-flex items-center gap-2 w-fit rounded-2xl border border-[#1c4848]/8 bg-[#fafbfc] pl-2.5 pr-3 h-[46px] shadow-[0_1px_2px_rgba(28,72,72,0.06)]"
    :class="accentClass"
  >
    <span class="difficulty-icon-box w-7 h-7 flex items-center justify-center shrink-0 rounded-lg bg-white border border-[#1c4848]/8 shadow-sm" aria-hidden="true">
      <svg v-if="displayLevel <= 1" class="difficulty-svg w-4 h-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <rect x="9" y="8" width="6" height="14" rx="3"/>
      </svg>
      <svg v-else-if="displayLevel <= 2" class="difficulty-svg w-4 h-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <rect x="3" y="8" width="6" height="14" rx="3"/><rect x="15" y="8" width="6" height="14" rx="3"/>
      </svg>
      <svg v-else class="difficulty-svg w-4 h-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <rect x="1" y="8" width="5" height="14" rx="2.5"/><rect x="9.5" y="8" width="5" height="14" rx="2.5"/><rect x="18" y="8" width="5" height="14" rx="2.5"/>
      </svg>
    </span>
    <span class="text-sm font-semibold text-[#1c4848] tracking-tight">{{ label }}</span>
    <select
      v-if="editable"
      v-model.number="localValue"
      class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
      aria-label="Difficulty"
    >
      <option :value="1">Easy</option>
      <option :value="2">Medium</option>
      <option :value="3">Hard</option>
    </select>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  difficulty: { type: Number, default: 1 },
  editable: { type: Boolean, default: false },
});

const emit = defineEmits(['update:difficulty']);

const displayLevel = computed(() => Math.max(1, Math.min(3, props.difficulty)));
const localValue = computed({
  get: () => displayLevel.value,
  set: (v) => emit('update:difficulty', Number(v)),
});

const label = computed(() => {
  const d = displayLevel.value;
  return d <= 1 ? 'Easy' : d <= 2 ? 'Medium' : 'Hard';
});

const accentClass = computed(() => {
  const d = displayLevel.value;
  return d <= 1 ? 'difficulty-easy' : d <= 2 ? 'difficulty-medium' : 'difficulty-hard';
});

</script>

<style scoped>
.difficulty-badge {
  position: relative;
}

.difficulty-badge.difficulty-easy {
  border-left: 3px solid #2d7a6e;
}
.difficulty-badge.difficulty-easy .difficulty-icon-box {
  color: #2d7a6e;
}
.difficulty-badge.difficulty-easy .difficulty-svg {
  fill: currentColor;
}

.difficulty-badge.difficulty-medium {
  border-left: 3px solid #b8860b;
}
.difficulty-badge.difficulty-medium .difficulty-icon-box {
  color: #b8860b;
}
.difficulty-badge.difficulty-medium .difficulty-svg {
  fill: currentColor;
}

.difficulty-badge.difficulty-hard {
  border-left: 3px solid #c45c5c;
}
.difficulty-badge.difficulty-hard .difficulty-icon-box {
  color: #c45c5c;
}
.difficulty-badge.difficulty-hard .difficulty-svg {
  fill: currentColor;
}
</style>
